import { SCOPE_CHANGED } from "./types";

export const setScopeDirty = (isDirty) => {
    return (dispatch) => {
        dispatch({ type: SCOPE_CHANGED, payload: {isDirty: isDirty} });
    }
}